export enum AnalyticsTargetTab {
	Assets,
	Anchors,
}
